<template>
  <div >


    <div class="container-fluid send_settings_top pl-3 pr-3 pb-3">

      <div class="parent_class" id="current_settings_id">
        <div v-if="this_active_outbound_campaign_uuid !== null && this_active_list_uuid !== null && this_active_script_uuid !== null && this.show_campaign_settings !== true" class="is_active_summary " >
          <b-row class="is_active_summary bkg_light_blue pt-1 pb-1">

            <b-col class="text-left">
              <base-button type="secondary" size="sm" outline class="" v-on:click="change_send_message_settings()">
                <span class="material-icons material-icons-outlined md-18">campaign</span>

                <span class="btn-inner--text"> {{this_active_outbound_campaign_name}}</span>
              </base-button>
              <base-button type="secondary" size="sm" outline class="" v-on:click="change_send_message_settings()">
                <span class="material-icons material-icons-outlined md-18">folder_shared</span>
                <span class="btn-inner--text"> {{this_active_list_name}}</span>
              </base-button>
              <base-button type="secondary" size="sm" outline class="" v-on:click="change_send_message_settings()">
                <span class="material-icons material-icons-outlined md-18">chat</span>
                <span class="btn-inner--text"> {{this_active_script_name}}</span>
              </base-button>
            </b-col>
            <b-col class="text-right">
              <base-button type="primary" size="sm" outline class="" v-on:click="change_send_message_settings()">
                <span class="material-icons material-icons-outlined md-18">edit</span>
                <span class="btn-inner--text">Edit Settings</span>
              </base-button>
            </b-col>
          </b-row>
        </div>
      </div>
      
      <div class="parent_class" id="main_campaign_settings_options"> 
        <div class="p-3" v-if="show_campaign_settings && show_campaign_settings === true">
          <b-row class="align-items-left">
            <b-col>
              <h2>Select Campaign Options:</h2>
            </b-col>
            
          </b-row>
          <b-row class="align-items-left">

            <b-col>
              <base-button type="secondary" size="sm" outline class="mb-2" v-on:click="$parent.change_tab('Campaigns')">
                <span class="btn-inner--icon pr-1"><span class="material-icons material-icons-outlined">campaign</span></span><!--notification-70-->
                <span class="btn-inner--text">Campaign</span>
              </base-button>
              <base-input label="">
                <el-select v-model="this_active_outbound_campaign_uuid" filterable
                          placeholder="Campaign">
                  <el-option v-for="campaign in $parent.active_outbound_campaigns" 
                            :key="campaign.outbound_campaign_uuid"
                            :label="campaign.campaign_name"
                            :value="campaign.outbound_campaign_uuid">
                  </el-option>
                  <!-- v-if="campaign.is_active === true" -->
                </el-select>
              </base-input>

            </b-col>
            <b-col>
              <base-button outline type="secondary" size="sm" class="mb-2" v-on:click="$parent.change_tab('Lists')">
                <span class="btn-inner--icon pr-1"><span class="material-icons material-icons-outlined">folder_shared</span></span>
                <span class="btn-inner--text">List</span>
              </base-button>
              <base-input label=""  v-if="this.$parent.available_lists_for_this_campaign && this.$parent.available_lists_for_this_campaign.length && this.$parent.available_lists_for_this_campaign.length > 0">
                <el-select  filterable
                          v-model="this_active_list_uuid"
                          placeholder="List">
                  <el-option v-for="list in $parent.available_lists_for_this_campaign" 
                          
                            :key="list.list_uuid"
                            :label="list.list_name"
                            :value="list.list_uuid">
                  </el-option>
                </el-select>
              </base-input>
              <base-input v-else >
                <p v-on:click="$parent.change_tab('Lists')">No lists available, active, or added into this campaign.</p>
              </base-input>
            </b-col>
            <b-col>
              <base-button outline type="secondary" size="sm" class="mb-2" v-on:click="$parent.change_tab('Scripts')">
                <span class="btn-inner--icon pr-1"><span class="material-icons material-icons-outlined">chat</span></span>
                <span class="btn-inner--text">Script</span>
              </base-button>
              <div>
                <base-input label="" v-if="$parent.available_scripts_for_this_campaign && $parent.available_scripts_for_this_campaign.length && $parent.available_scripts_for_this_campaign.length > 0">
                  <el-select filterable
                            v-model="this_active_script_uuid"
                            placeholder="Script">
                    <el-option v-for="script in $parent.available_scripts_for_this_campaign"
                              :key="script.script_uuid"
                              :label="script.script_name"
                              :value="script.script_uuid">
                    </el-option>
                  </el-select>
                </base-input>
                <base-input v-else>
                  <p v-on:click="$parent.change_tab('Scripts')">No scripts available, active, or added into this campaign.</p>
                </base-input>
              </div>
              
              
            </b-col>
            
          </b-row>
        </div>
      </div>
      
      





    </div>
    
    <b-container fluid class="p-3" v-if="this_active_outbound_campaign_uuid !== null && this_active_list_uuid !== null && this_active_script_uuid !== null">
      
      <b-row v-if="this.$parent.active_script && $parent.active_campaign && this.$parent.active_list && this.$parent.active_script.script_uuid && this.$parent.active_campaign.outbound_campaign_uuid && this.$parent.active_list.list_uuid && this.$parent.contacts && this.$parent.contacts.length  && this.$parent.contacts.length > 0 && this.$parent.active_contact.contact_uuid && this.$parent.active_contact.contact_uuid !== null"><!-- send message block -->
        <b-col >
         

          <div class="progress_contain">
            <div v-if="this.this_campaign_stats && this.this_campaign_stats.sent_to" class="progress-wrapper">
   
              <div class="progress-success">
                  <div class="progress-label-left">
                    <h2>Send Messages:</h2>
                  </div>
                  <div class="progress-label-right">
                    <span v-if="isNaN(this.percent_sent_of_this_campaign_list)">0%</span>
                    <span v-else>{{this.percent_sent_of_this_campaign_list}}%</span>
                  </div>
              </div>
              <div style="clear:both;"></div>
              <base-progress
                              type="success" animated
                              :value="this.percent_sent_of_this_campaign_list"
                              size="lg"> 
                            
              </base-progress>
  
            </div>
            <div v-else>
              <h2>Send Messages:</h2>
            </div>
          </div>

          <div class="card-wrapper" v-if="this.$parent.active_contact.contact_uuid && this.$parent.active_contact.contact_uuid !== null">
            <card>     

              <form v-on:submit.prevent="onSubmit">
                <b-row class="mb-4 cl-success" >
                    <b-col>
                        <base-button icon type="primary" v-on:click="send_this_message" :disabled="this.message_sending_in_progress">
                            <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18">send</span></span>
                            <span class="btn-inner--text">Send This Message</span>
                        </base-button>
                    </b-col>

                    <b-col class="justify-content-md-right">
                        <base-button icon type="light" v-on:click="skip_send_message_load_next_contact" :disabled="this.message_skip_in_progress">
                            <span class="btn-inner--icon"><span class="material-icons material-icons-outlined md-18">skip_next</span></span>
                            <span class="btn-inner--text">Skip Next Contact</span>
                        </base-button>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col>
                        <b-form-group>
                            <b-input-group prepend="Text">
                                <b-form-textarea id="outgoing_message_text" required v-model="$parent.active_message.body" rows="7" :disabled="this.message_sending_in_progress"></b-form-textarea>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col v-if="$parent.active_message.sms_attachment" md="2" class="mb-2 mini_plugin_small_image">
                      <div v-if="$parent.active_message.sms_attachment.endsWith('.jpg') || $parent.active_message.sms_attachment.endsWith('.gif') || $parent.active_message.sms_attachment.endsWith('.png')">
                        <img  v-if="$parent.active_message.sms_attachment" :src="$parent.active_message.sms_attachment" alt="SMS image preview. invalid URL or file not accessible to web." class="w-100">
                      </div>
                      <div v-if="$parent.active_message.sms_attachment.endsWith('.mp4') || $parent.active_message.sms_attachment.endsWith('.mpeg') " class="w-100">
                        <video controls class="w-100">
                          <source :src="$parent.active_message.sms_attachment" type="video/mp4">
                        </video>
                      </div>
                      <div v-if="$parent.active_message.sms_attachment.endsWith('.vcf')" class="w-100">
                       <p><a :href="$parent.active_message.sms_attachment">Download contact card</a></p>
                      </div>
                      <div v-if="$parent.active_message.sms_attachment.endsWith('.ics') || $parent.active_message.sms_attachment.endsWith('.icalendar') || $parent.active_message.sms_attachment.endsWith('.ical')" class="w-100">
                       <p><a :href="$parent.active_message.sms_attachment">Download calendar event</a></p>
                      </div>
                      <div v-if="$parent.active_message.sms_attachment.endsWith('.mp3') || $parent.active_message.sms_attachment.endsWith('.wav') " class="w-100">
                        <audio class="w-100">
                          <source :src="$parent.active_message.sms_attachment" type="audio/mp3" v-if="$parent.active_message.sms_attachment.endsWith('.mp3')">
                          <source :src="$parent.active_message.sms_attachment" type="audio/wav" v-if="$parent.active_message.sms_attachment.endsWith('.wav')">
                        </audio>
                      </div>
                      <div v-else>
                        <!--since can end with params and stuff just assume image -->
                        <img  v-if="$parent.active_message.sms_attachment" :src="$parent.active_message.sms_attachment" alt="SMS image preview. invalid URL or file not accessible to web." class="w-100">
                      </div>
                     
                    </b-col>
                </b-row>
                
                <!-- Input groups with icon -->
                <b-row>
                  <b-col>
                    <base-input v-if="$parent.active_contact" prepend-icon="account_circle" placeholder="First Name" v-model="$parent.active_contact.first_name" :disabled="this.message_sending_in_progress"></base-input>
                    <base-input v-else prepend-icon="account_circle" placeholder="First Name"  :disabled="this.message_sending_in_progress"></base-input>
                  </b-col>
                  <b-col>
                    <base-input v-if="$parent.active_contact" prepend-icon="account_circle" placeholder="Last Name" v-model="$parent.active_contact.last_name" :disabled="this.message_sending_in_progress"></base-input>
                    <base-input v-else prepend-icon="account_circle" placeholder="Last Name"  :disabled="this.message_sending_in_progress"></base-input>
                  </b-col>
                  <b-col  md="2">
                        <base-input prepend-icon="image" v-model="$parent.active_script.sms_attachment" type="url" :disabled="this.message_sending_in_progress">
                        </base-input>
                    </b-col>
                </b-row>
                
              </form>
            </card>

            <div class="card-wrapper">
            
                <stats-card type="gradient-white"
                            icon="contact_phone"
                            class="blue_bkg">
        

                    <p class="card-title text-uppercase text-white mb-0">Sending To:</p>
                    <span class="h2 font-weight-bold mb-0 text-white" v-if="this.$parent.active_contact && this.$parent.active_contact.first_name && this.$parent.active_contact.last_name">{{this.$parent.active_contact.first_name}} {{this.$parent.active_contact.last_name}}</span>
                    <template slot="footer">
                      <div v-if="this.$parent.active_contact && this.$parent.active_contact.sent_to">
                        <span class="text-white mr-5"><span class="material-icons material-icons-outlined">phone_iphone</span> {{this.$parent.active_contact.sent_to}}</span>
                      </div>
                      <div v-else>
                        <span class="text-white mr-5"><span class="material-icons material-icons-outlined">phone_iphone</span> {{this.$parent.active_message.sent_to}}</span>
                      </div>
                      
                      <span class="text-white mr-5" v-if="this.$parent.active_contact && this.$parent.active_contact.email"><span class="material-icons material-icons-outlined">alternate_email</span> <a v-on:click="this.compose_front_email(this.$parent.active_contact.email)">{{this.$parent.active_contact.email}}</a></span>
                      <span class="text-nowrap text-white mr-5" v-if="this.$parent.active_contact && this.$parent.active_contact.city && this.$parent.active_contact.state"><span class="material-icons material-icons-outlined">location_city</span> {{this.$parent.active_contact.city}}, {{this.$parent.active_contact.state}}</span>
                      <span class="text-white mr-5" v-if="this.$parent.active_contact && this.$parent.active_contact.van_id"><span class="material-icons material-icons-outlined">inventory</span> <a v-on:click="this.open_van_id(this.$parent.active_contact.van_id)"> NGPVAN: {{this.$parent.active_contact.van_id}}</a></span>
                    </template>
        
                </stats-card>
            
            </div>

            <div class="card-wrapper">
            
                <stats-card type="gradient-white"
                            icon="send_to_mobile"
                            class="light_blue_card">

                    <p class="card-title text-uppercase text-white mb-0">Sending From:</p>
                    <div>
                      <div v-if="this.$parent.active_message && this.$parent.active_message.phone_number">
                        <span class="h2 font-weight-bold mb-0 text-white">{{this.$parent.active_message.phone_number}}</span>
                      </div>
                      <div v-else-if="this.computed_messaging_service_name" >
                        <span class="h2 font-weight-bold mb-0 mr-2 text-white">
                          {{this.computed_messaging_service_name}}
                        </span>

                        <span v-for="phone_number in computed_messaging_service_phone_numbers" class="mr-3 font-14"><span class="material-icons material-icons-outlined push_icon_down">phone_iphone</span> {{phone_number}}</span>

                      </div>
                    </div>
                    
                </stats-card>
            
            </div>
           


          </div><!--card wrapper div end-->
        </b-col>
      </b-row><!-- send message block -->

      <b-row v-else><!-- must have contact -->
        <b-col>
          
        
            <b-alert show dismissible variant="success">
                <span class="alert-icon"><span class="material-icons material-icons-outlined">sentiment_satisfied</span></span>
                <span class="alert-text"><strong>Finished!</strong> There are no more contacts! Change your list or uplod new contacts.</span>
            </b-alert>

           
        </b-col>
      </b-row><!-- must have contact -->

    </b-container>
    <b-container>
      <b-row>
        <b-col align-v="center" style="text-align:center">
          <div v-if="this.$parent.is_fetching_new_contacts && this.$parent.is_fetching_new_contacts === true">
            <p>Loading new contacts...</p>
            <div style="max-width: 80px;margin:0 auto;">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="L4" x="0px" y="0px" enable-background="new 0 0 0 0" xml:space="preserve" viewBox="0 44 52 12" style="max-width:80px">
                <circle fill="var(--blue)" stroke="none" cx="6" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.1"/>    
                </circle>
                <circle fill="var(--blue)" stroke="none" cx="26" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.2"/>       
                </circle>
                <circle fill="var(--blue)" stroke="none" cx="46" cy="50" r="6">
                    <animate attributeName="opacity" dur="1s" values="0;1;0" repeatCount="indefinite" begin="0.3"/>     
                </circle>
              </svg>
            </div>
            
          </div>
        </b-col>
      </b-row>
      
    </b-container>
    
  </div>
</template>

<script>
  import { Select, Option } from 'element-ui'
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import swal from 'sweetalert2';
  import helpers from '@/util/helpers.js'

  import { BSpinner } from 'bootstrap-vue'

  export default {
    name: 'form-components',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      BSpinner: BSpinner
    },
    data() {
      return {
        message_sending_in_progress: false,
        message_skip_in_progress: false,
        loading_next_contact: false,
        count_message_send_errors: 0,
        this_active_list_uuid: null,
        this_active_script_uuid: null,
        this_active_outbound_campaign_uuid: null,
        local_is_requesting_new_contacts: false,
        this_active_local_campaign_send_stats: {},
        count_int_before_force_stats_reset: 0,
        send_these_before_stats_reset: 50,
        
        show_campaign_settings: true
      }
    },
    
    
    mounted: function() {
      this.check_is_all_settings_set_true()

    },
    computed: {
      computed_messaging_service_name:function() {
        try {
          if(this.$parent.active_message && this.$parent.active_message.messaging_service_sid && this.$parent.active_message.messaging_service_sid !== null) {
            if(this.$parent.message_services && this.$parent.message_services.length && this.$parent.message_services.length > 0) {
              let matched_message_service_name = null
              this.$parent.message_services.forEach(message_service => {
                if(message_service.messaging_service_sid === this.$parent.active_message.messaging_service_sid) {
                  matched_message_service_name = message_service.messenger_service_name
                }
              })
              return matched_message_service_name
            } else {
              return null
            }
          } else {
            return null
          }
        } catch(e) {
          console.log(e)
          return null
        }
      },
      computed_messaging_service_phone_numbers: function() {
        try {
          if(this.$parent.active_message && this.$parent.active_message.messaging_service_sid && this.$parent.active_message.messaging_service_sid !== null) {
            if(this.$parent.message_services && this.$parent.message_services.length && this.$parent.message_services.length > 0) {
              let matched_messaging_service_numbers_array = []
              this.$parent.message_services.forEach(message_service => {
                if(message_service.messaging_service_sid === this.$parent.active_message.messaging_service_sid) {
                  matched_messaging_service_numbers_array = message_service.numbers
                }
              })
              return matched_messaging_service_numbers_array
            } else {
              return []
            }
          } else {
            return []
          }
        } catch(e) {
          console.log(e)
          return []
        }
      },
      this_active_outbound_campaign_name:function() {
        try {
          if(typeof this.this_active_outbound_campaign_uuid !== 'undefined' && this.this_active_outbound_campaign_uuid !== null && typeof this.$parent.active_campaign.campaign_name !== 'undefined' && this.$parent.active_campaign.campaign_name !== null) {
            return this.$parent.active_campaign.campaign_name
          }
        } catch(e) {
          console.log(e)
          return null
        }
      },
      this_active_script_name: function() {
        try {
          if(typeof this.this_active_script_uuid !== 'undefined' && this.this_active_script_uuid !== null && typeof this.$parent.active_script.script_name !== 'undefined' && this.$parent.active_script.script_name !== null) {
            return this.$parent.active_script.script_name
          }
        } catch(e) {
          console.log(e)
          return null
        }
      },
      this_active_list_name: function() {
        try {
          if(typeof this.this_active_list_uuid !== 'undefined' && this.this_active_list_uuid !== null && typeof this.$parent.active_list.list_name !== 'undefined' && this.$parent.active_list.list_name !== null) {
            return this.$parent.active_list.list_name
          }
        } catch(e) {
          console.log(e)
          return null
        }
      },



      this_campaign_stats: function() {
        try {
          let this_current_campaign = {}

          //use local for now
          if(typeof this.this_active_local_campaign_send_stats !== 'undefined' && this.this_active_local_campaign_send_stats.outbound_campaign_uuid === this.this_active_outbound_campaign_uuid) {

            return this.this_active_local_campaign_send_stats
          } else {

            if(typeof this.$parent.outbound_campaigns_stats !== 'undefined' && this.$parent.outbound_campaigns_stats.length && this.$parent.outbound_campaigns_stats.length > 0 ) {

              this.$parent.outbound_campaigns_stats.forEach(campaign_stats => {

                if(campaign_stats.outbound_campaign_uuid === this.this_active_outbound_campaign_uuid) {
                  
                  this_current_campaign = campaign_stats
                }
              });
            } else {
              console.log('no parent campaigns?')
            }
            return this_current_campaign
          }

          
        } catch(e) {
          console.log(e)
          return null
        }
      },
      this_active_list_stats: function() {
        try {
          let this_current_list = {}
          if(typeof this.$parent.contact_lists_stats !== 'undefined' && this.$parent.contact_lists_stats.length && this.$parent.contact_lists_stats.length > 0 ) {
            
            this.$parent.contact_lists_stats.forEach(list_stats => {
              if(list_stats.list_uuid === this.this_active_list_uuid) {
                this_current_list = list_stats
              }
            });
          }
          return this_current_list
        } catch(e) {
          console.log(e)
          return null
        }
      },
      percent_sent_of_this_campaign_list: function() {
        try {
          console.log(this.this_campaign_stats.sent_to)
          console.log(this.this_active_list_stats.twilio_verified_cell)
          if(typeof this.this_campaign_stats.sent_to !== 'undefined' && this.this_active_list_stats.twilio_verified_cell !== 'undefined') {
            let the_number = ( this.this_campaign_stats.sent_to  / this.this_active_list_stats.twilio_verified_cell ) *100
            the_number = Math.round(the_number)
            if(isNaN(the_number)) {
              the_number = 0
            }
            return the_number
          } else {
            return 0
          }
        } catch(e) {
          console.log(e)
          return 0
        }
      }
    },
    watch: {
      this_active_outbound_campaign_uuid: {
        handler: function(newVal,oldVal) {
          //console.log('debug  new changed this_active_outbound_campaign_uuid')
          if(newVal && newVal !== null && typeof newVal !== 'undefined') {
            this.check_is_all_settings_set_true()

            if(newVal !== oldVal) {
              //make sure it's actually new from the parent current active
              if( (this.$parent.active_outbound_campaign_uuid && this.$parent.active_outbound_campaign_uuid === newVal) || (this.$parent.active_outbound_campaign_uuid && this.$parent.active_outbound_campaign_uuid === newVal)) {
                //console.log('debug this new selected outbound_campaign_uuid is already set in parent')
              } else {
                this.$parent.active_contact = helpers.empty_active_contact()
                this.this_active_list_uuid = null
                this.this_active_script_uuid = null

                this.$parent.active_outbound_campaign_uuid = newVal

                //make a copy of current stats locally
                if(typeof this.$parent.outbound_campaigns_stats !== 'undefined' && this.$parent.outbound_campaigns_stats.length >0) {
                  console.log('369')
                  let found_this_stat = null
                  this.$parent.outbound_campaigns_stats.forEach(this_stat => {
                    if(this_stat.outbound_campaign_uuid === this.this_active_outbound_campaign_uuid) {
                      found_this_stat = this_stat
                    }
                  });

                  if(found_this_stat !== null) {
                    console.log('found_this_stat')
                    console.log(found_this_stat)
                    this.this_active_local_campaign_send_stats = found_this_stat
                  }

                  this.check_is_all_settings_set_true()

                }
                
                //dont need to cascade parent watch will
                //this.$parent.cascade_updates_on_new_active_campaign()

                //removed the set timeout hack. just manually make people select the list and script
              }
              
            }
            
          }
        }

        
      },
      this_active_list_uuid: {
        handler: function(newVal,oldVal) {
          //console.log('debug  new this_active_list_uuid')
          if(newVal && newVal !== null && typeof newVal !== 'undefined') {
            this.check_is_all_settings_set_true()
            if(newVal !== oldVal) {
              //bug from somewhere returning 404 is not reseting so just do it here first and faster
              
              if(this.this_active_list_uuid !== this.$parent.active_list.list_uuid) {
                this.$parent.active_contact = helpers.empty_active_contact()
                //console.log('debug set this new selected active_list ' + newVal)
                this.$parent.set_active_list(newVal)
              }  else {
                //console.log('debug this_active_list_uuid already equals parent active_list.list_uuid')
              }
              
            }
            
          }
        }
      },
      this_active_script_uuid: {
        handler: function(newVal,oldVal) {
          //console.log('debug  new this_active_script_uuid')
          if(newVal && newVal !== null && typeof newVal !== 'undefined') {
            this.check_is_all_settings_set_true()
            if(newVal !== oldVal) {

              //bug from somewhere returning 404 is not reseting so just do it here first and faster
              //this.this_active_script_uuid
              if(this.$parent.active_script && this.$parent.active_script.script_uuid !== null) {
                if(newVal !== this.$parent.active_script.script_uuid) {
                  //console.log('debug set this new selected active_script ' + newVal)
                  this.$parent.set_active_script(newVal)
                } else {
                  //console.log('this script uuid already matches the parent')
                }
              } else {
                console.log('parent active script uuid should be null')
                this.$parent.set_active_script(newVal)
              }
              
              
            }
            
          }
        }
      }
      
    },
    methods: {
      check_is_all_settings_set_true: function() {

        try {
          if(!this.this_active_outbound_campaign_uuid || this.this_active_outbound_campaign_uuid === null || !this.this_active_list_uuid || this.this_active_list_uuid === null || !this.this_active_script_uuid || this.this_active_script_uuid === null) {
            this.show_campaign_settings = true
          } else {
            this.show_campaign_settings = false
          }
        } catch(e) {
          console.log(e)
        }
      },
      change_send_message_settings: function() {
        try {
          this.show_campaign_settings = true   
        } catch(e) {
          console.log(e)
        }
      },
      compose_front_email: function(email)  {
        console.log('TODO: add FRONT plugin integration here to: ' + email)

      },
      open_van_id: function(van_id) {
        console.log('TODO add FRONT plugin integration van_id: ' + van_id)
      },
      load_new_contact: function(double_verify_this_sending_contact_uuid) {

       // console.log('load_new_contact')

        //triple check we removed the contact so no state error double sends
        //this.remove_this_contact(double_verify_this_sending_contact_uuid)

        //set the new active contact
        //220125 ????
        try {
          if(this.$parent.contacts && this.$parent.contacts.length && this.$parent.contacts.length > 0) {
            this.$parent.active_contact = this.$parent.contacts[0]
          }
        } catch(e) {
          console.log(e)
          return null
        }
        

        let grab_this_many_contacts = 30
      
        //TODO re look at this logic just grab 30 right now
        if(this.$parent.contacts && this.$parent.contacts.length <14  && this.$parent.contacts.length <100) {
          //console.log('parent contacts array less 9 and 100')
          //console.log(this.$parent.is_fetching_new_contacts)
          if(this.$parent.is_fetching_new_contacts && this.$parent.is_fetching_new_contacts === true) {
            //console.log('parent is true')
          } else {
            //console.log('parent is not true')
            //230308 change to bernoulli?
            this.$parent.grab_new_contacts(grab_this_many_contacts,this.$parent.active_list.list_uuid,'ordered_limit')
          }

          //console.log('lengh < 8')

          //if(this.$parent.is_fetching_new_contacts &&  this.$parent.is_fetching_new_contacts !== true) {
            //console.log('too few contacts load more')
            //if queue is < 3 grab another 10
            
            //use this.$parent.stats.messages_sent_this_session
            /*
            if(this.$parent.stats.messages_sent_this_session && Number.isInteger(this.$parent.stats.messages_sent_this_session)) {
              //just do steps so doesnt go over limit
              if(this.$parent.stats.messages_sent_this_session > 20) {
                grab_this_many_contacts = 15
              } else if(this.$parent.stats.messages_sent_this_session > 50) {
                grab_this_many_contacts = 20
              }  else if(this.$parent.stats.messages_sent_this_session > 75) {
                grab_this_many_contacts = 25
              } else if(this.$parent.stats.messages_sent_this_session > 120) {
                grab_this_many_contacts = 30
              }

            }
            */
        
            
            //this function sets new active_contact
          //}
          
        } 

        this.reset_form()
        
      },
      reset_form: function() {
        //reset the form button
        //this.end_timer = performance.now()

        //admin can go faster
        let this_speed_cap = 700
        if(this.$parent.active_user && this.$parent.active_user.admin && this.$parent.active_user.admin === true) {
          this_speed_cap = 250
        }
        if(this.start_timer) {
          if((performance.now() - this.start_timer) < this_speed_cap) {
            setTimeout(() => {
              this.message_sending_in_progress = false
              this.message_skip_in_progress = false
            }, this_speed_cap);
          } else {
            this.message_sending_in_progress = false
            this.message_skip_in_progress = false
          }
        } else {
          this.message_sending_in_progress = false
          this.message_skip_in_progress = false
        }

        

      },
      start_timer_function: function() {
        this.start_timer = performance.now()
      },
      skip_send_message_load_next_contact: function(event) {
        //console.log('skip')
        this.loading_next_contact = true

        this.$parent.stats.messages_skipped = this.$parent.stats.messages_skipped + 1

        this.update_send_stats(false)

        if(!this.$parent.active_message.contact_uuid || !this.$parent.active_contact.contact_uuid || (this.$parent.active_message.contact_uuid !== this.$parent.active_contact.contact_uuid ) ) {
          console.log('error mis match active_message and active_contact state?')
          console.log(JSON.stringify(this.$parent.active_message))
          console.log(JSON.stringify(this.$parent.active_contact))
        }

        let double_verify_this_sending_contact_uuid = this.$parent.active_message.contact_uuid+''
        this.remove_this_contact(this.$parent.active_message.contact_uuid+'')
        this.load_new_contact(double_verify_this_sending_contact_uuid) 

      },
      remove_this_contact: function(contact_uuid,return_function) {

        if(contact_uuid && contact_uuid !== null) {
          //simple check if is the first in contacts, it should be
          if(this.$parent.contacts) {
            console.log(this.$parent.contacts.length)
            if(this.$parent.contacts[0] && this.$parent.contacts[0].contact_uuid === contact_uuid) {
              this.$parent.contacts.splice(0, 1);
            } else {
              //loop through
              this.$parent.contacts.forEach((parent_contact,index) => {
                if(parent_contact.contact_uuid && parent_contact.contact_uuid === contact_uuid) {
                  this.$parent.contacts.splice(index, 1);
                }
              });
            }
          }

          
          /*
          this.$nextTick(() => {
            if(this.$parent.active_contact && this.$parent.active_contact.contact_uuid && this.$parent.active_contact.contact_uuid === contact_uuid) {
              this.$parent.active_contact = helpers.empty_active_contact()
            }
            if(typeof return_function !== 'undefined') {
              return return_function()
            } else {
              return
            }
           })
           */
          
        }

      },
      update_send_stats: function(status) {
        try {
          if(typeof status !== 'undefined' && status === false) {
            this.$parent.message_failed = this.$parent.message_failed+1

          }

          this.$parent.messages_sent_this_session = this.$parent.messages_sent_this_session + 1

          if(typeof this.this_active_local_campaign_send_stats.sent_to !== 'undefined') {
            this.this_active_local_campaign_send_stats.sent_to = this.this_active_local_campaign_send_stats.sent_to + 1
            this.this_active_local_campaign_send_stats.count_all = this.this_active_local_campaign_send_stats.count_all + 1
          } else {
            //TODO add a reloading check here
          }

          //do math for how many times sent and then force refresh on parent for that contact_list after like idk 50?
          this.count_int_before_force_stats_reset = this.count_int_before_force_stats_reset + 1
/*
          if(this.count_int_before_force_stats_reset && this.count_int_before_force_stats_reset > this.send_these_before_stats_reset ) {
      
            console.log('reset counts')
            this.send_these_before_stats_reset = 0
            this.count_int_before_force_stats_reset = 0

            if(typeof this.active_outbound_campaign_uuid === 'undefined' || this.active_outbound_campaign_uuid === null) {
              console.log('this.active_outbound_campaign_uuid is empy or null?')
            } else {
              this.$parent.get_outbound_campaign_stats(this.active_outbound_campaign_uuid)
            }
            
          }
       
*/

        } catch(e) {
          console.log(e)
        }
        
        
      },
      send_this_message: function(event) {
        //console.log(event)
        var send_timer = (event) => {
          this.message_sending_in_progress = true
          this.start_timer_function()

          //check user has permissions here
          if(!this.$parent.active_user || !this.$parent.active_user.permissions.includes('messages:send') || this.$parent.active_user.user_uuid === null) {
            console.log('active_user is missing values or doesnt have messages:send permissions')
            return swal.fire({
              title: `Warning`,
              text: 'This user does not have permissions to send messages',
              buttonsStyling: false,
              icon: 'warning'
            })
          }

          if(!this.$parent.active_message.contact_uuid || !this.$parent.active_contact.contact_uuid || (this.$parent.active_message.contact_uuid !== this.$parent.active_contact.contact_uuid ) ) {
            console.log('error mis match active_message and active_contact state?')
            console.log(JSON.stringify(this.$parent.active_message))
            console.log(JSON.stringify(this.$parent.active_contact))
            return swal.fire({
              title: `Warning`,
              text: 'Do not click send this fast',
              buttonsStyling: false,
              icon: 'warning'
            })
          }


          //check this.parent.active_message has good data
          if(
            !this.$parent.active_message || 
            !this.$parent.active_contact.contact_uuid || 
            this.$parent.active_campaign.campaign_uuid === null || 
            this.$parent.active_org.org_id === null ||
            this.$parent.active_user.user_uuid === null ||
            this.$parent.active_list.list_uuid === null ||
            this.$parent.active_script.script_uuid === null ||
            this.$parent.outbound_campaign_type === null ||
            this.$parent.active_messenger_service.account_sid === null ||
            !this.$parent.active_messenger_service.account_sid ||
            this.$parent.active_contact.contact_uuid === null ||
            !this.$parent.active_message.sent_to ||
            this.$parent.active_message.sent_to === null
          ) {

            console.log(this.$parent.active_message)
            console.log(this.$parent.active_contact.contact_uuid)
            console.log(this.$parent.active_campaign.campaign_uuid)
            console.log(this.$parent.active_org.org_id)
            console.log(this.$parent.active_user.user_uuid)
            console.log(this.$parent.active_list.list_uuid)
            console.log(this.$parent.active_script.script_uuid)
            console.log(this.$parent.outbound_campaign_type)
            console.log(this.$parent.active_messenger_service.account_sid)
            console.log(this.$parent.active_messenger_service.account_sid)
            console.log(this.$parent.active_contact.contact_uuid)
            console.log(this.$parent.active_message.sent_to)
            console.log(this.$parent.active_message.sent_to)


            console.log('missing required data to send message?')
            swal.fire({
              title: `Warning`,
              text: 'Error sending message, make sure you did not remove the entire message or contact information.',
              buttonsStyling: false,
              icon: 'warning'
            })
            return
          }

          //has body or media_url
          if(
            ( !this.$parent.active_message.body && !this.$parent.active_message.sms_attachment ) ||
            ( this.$parent.active_message.body === null && this.$parent.active_message.sms_attachment === null) 
          ) {
            swal.fire({
              title: `Warning`,
              text: 'Error sending message, must have body or media url.',
              buttonsStyling: false,
              icon: 'warning'
            })
            return
          }

          ///messenger_service_sid or from number
          if(
            ( this.$parent.active_messenger_service.messaging_service_sid === null && this.$parent.active_message.phone_number === null ) ||
            ( !this.$parent.active_messenger_service.messaging_service_sid && !this.$parent.active_message.phone_number )

          ) {
            swal.fire({
              title: `Warning`,
              text: 'Error sending message, missing required messaging service settings. contact admin',
              buttonsStyling: false,
              icon: 'warning'
            })
            return
          }

          if(!this.$parent.active_message.contact_uuid || !this.$parent.active_contact.contact_uuid || (this.$parent.active_message.contact_uuid !== this.$parent.active_contact.contact_uuid ) ) {
            console.log('error mis match active_message and active_contact state?')
            console.log(JSON.stringify(this.$parent.active_message))
            console.log(JSON.stringify(this.$parent.active_contact))
            swal.fire({
              title: `Warning`,
              text: 'Error sending message, state error mismatching contact uuid s',
              buttonsStyling: false,
              icon: 'warning'
            })
            return
          }

          //update stats
          this.$parent.stats.messages_sent = this.$parent.stats.messages_sent + 1
          this.$parent.stats.messages_sent_string = this.$parent.stats.messages_sent.toString()

          //TODO game ify if they hit milestones show fireworks or some shit
          this.$parent.stats.messages_sent_this_session = this.$parent.stats.messages_sent_this_session+1
          //https://github.com/ra-utility/vue-firework#readme


          //xhr post to backend
          let send_this_message = {
            "org_id":this.$parent.active_org.org_id,
            "user_uuid_created":this.$parent.active_user.user_uuid,
            "outbound_campaign_uuid":this.$parent.active_message.outbound_campaign_uuid,
            "list_uuid":this.$parent.active_message.list_uuid,
            "script_uuid":this.$parent.active_message.script_uuid,
            "outbound_campaign_type":this.$parent.active_message.outbound_campaign_type || 'SMS',
            "contact_uuid":this.$parent.active_message.contact_uuid,
            "account_sid":this.$parent.active_message.account_sid,
            "messaging_service_sid":this.$parent.active_message.messaging_service_sid || null,
            
            "sent_to":this.$parent.active_message.sent_to,
            "body":this.$parent.active_message.body || null,
            "media_url":this.$parent.active_message.sms_attachment || null,
            "individual_message":false
          }


          if(typeof this.$parent.active_message.phone_number !== 'undefined' && this.$parent.active_message.phone_number !== null && this.$parent.active_message.phone_number.startsWith('+1')) {
            send_this_message.from = this.$parent.active_message.phone_number
          }

          send_this_message = JSON.parse(JSON.stringify(send_this_message))
        
          let double_verify_this_sending_contact_uuid = send_this_message.contact_uuid+''
        
          //let remove_promise_force = new Promise((resolve, reject) => {
          this.remove_this_contact(double_verify_this_sending_contact_uuid)

          //console.log('about to send this message:')
          //console.log(JSON.stringify(send_this_message))

          axios.post( 'https://'+this.$parent.use_this_api_domain+'/outbound_campaign/message',
                send_this_message, {
                    headers: {
                      'Authorization': 'Bearer ' + this.$parent.active_user_jwt
                    }
                  })
            .then((result) => {
              //console.log(result.data)

              //push this message into recent sent
              this.update_send_stats(result.data.status || false)


            })
            .catch((result) => {
              this.count_message_send_errors = this.count_message_send_errors+1
              if(this.count_message_send_errors > 3) {
                swal.fire({
                    title: `Error Sending Message`,
                    buttonsStyling: false,
                    icon: 'warning'
                })
              }
              console.log('send new message error:')
              console.log(result)

              this.update_send_stats(false)
              
            })
            .then(() => {
            
              this.load_new_contact(double_verify_this_sending_contact_uuid) 

            })
        }//send_timer

        
        if(this.message_sending_in_progress && this.message_sending_in_progress===true) {
          setTimeout(() => {
            console.log('debug too fast new set timer')
            if(this.message_sending_in_progress && this.message_sending_in_progress !== true) {
              send_timer(event)
            }
          }, 1000)
        } else {
          send_timer(event)
        }
        
        


      }
     
    }
  }

  
  

</script>

<style>
.bkg_light_blue {
  background: var(--blue-lighter)
}
.is_active_summary {
  margin-top: 0px;
}
.is_active_summary .btn {
  margin-bottom:0px;
}

.is_active_summary .btn-inner--text {
  vertical-align:  text-top;
}

.show_settings_options {
  display:block;
}

.hide_settings_summary {
  display:none;
}

.justify-content-md-right {
    -webkit-box-pack: center !important;
    -ms-flex-pack: center !important;
    justify-content: center !important;
  }
  .justify-content-md-right .btn {
    float:right;
  }
  .color_green {
    color: var(--success)  !important;
  }
  .color_red {
    color: var(--danger) !important;
  }
  textarea {
    overflow-wrap: break-word;
    hyphens: manual;
  }

  .progress-label-left {
    float:left;
    text-align:  left;
    width: 50%;
  }
  .progress-label-right {
    float:right;
    width: 50%;
    text-align:  right;
  }
  .icon.bg-gradient-white .material-icons {
    color:var(--blue)
  }
  .material-icons {
    vertical-align: middle;
  }

  .card-wrapper .blue_bkg  {
    background:var(--blue) !important;
  }
  .card-wrapper .light_blue_card {
    color: var(--blue-darker) !important;
    background: var(--blue-lighter) !important;
  }
  .card-wrapper .light_blue_card .text-white {
    color:var(--blue-darker) !important;
  }
  .font-14 {
    font-size:14px;
  }
  .font-14 .push_icon_down {
    font-size:16px;
  }
  .push_icon_down {
    vertical-align:baseline;
    margin-right:-2px;
    font-size:16px;
  }

@media only screen and (max-width: 800px) {
  .mini_plugin_small_image  {
    max-width: 200px;
    margin:0 auto;
    text-align:center;
  }
  .mini_plugin_small_image img, .mini_plugin_small_image image, .mini_plugin_small_image video {
    width: 100%;
    box-sizing: border-box;
  }
}
  
</style>